<template>
  <Modal :visible="visible" :draggable="true" :mask="false" :maskClosable="false" width="min(500px, 98%)"
    modalClass="modal-overlay" :title="getTranslatedText('watch live')" @onUnVisible="handleUnVisible">
    <div class="modal-content">
      <h5 v-if="!isLogin">
        {{ getTranslatedText("please log in to watch the live") }}
      </h5>
      <h5 v-else-if="messageError">{{ messageError }}</h5>

      <iframe v-else :src="embedUrl" frameborder="0" allowfullscreen width="100%" height="100%" allow="autoplay" />
    </div>
  </Modal>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import { Modal } from "usemodal-vue3";
import EventBus from "@/utils/EventBus";
import LiveStreamService from "@/services/live-stream/index.service";

export default {
  mixins: [languageMixins],
  components: { Modal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    gameId: {
      type: Number,
    },
  },
  watch: {
    visible: {
      handler(visible) {
        if (visible) {
          console.log("visible", visible);
          this.initOnClickCloseModal();
          this.handleGetLinkLiveStream(this.gameId);
        } else {
          this.clearInterval();
        }
      },
      deep: true,
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  data() {
    return {
      messageError: "",
      eventStartTime: null,
      intervalTimer: null,
      embedUrl: "",
      intervalSet: false,
    };
  },

  methods: {
    async handleGetLinkLiveStream(gameId) {
      if (!this.isLogin) return;
      try {
        const { result } = await LiveStreamService.getLinkLiveStream(gameId);
        this.eventStartTime = result?.event?.start_date;

        const stream = result?.stream;
        this.messageError = stream?.error || "";

        if (!stream?.error) {
          this.embedUrl = stream?.embedUrl || stream?.phenixEmbedUrl;
          this.clearInterval();
        } else {
          this.setIntervalToCheckLiveStream();
        }
      } catch (error) {
        console.log(error);
      }
    },
    initOnClickCloseModal() {
      setTimeout(() => {
        var modalHeader = document.querySelector(".modal-vue3-header");
        if (modalHeader) {
          var secondDiv = modalHeader.children[1];
          if (secondDiv) {
            secondDiv.addEventListener("click", function () {
              EventBus.emit("play-live-stream", false);
              localStorage.setItem("showLiveStream", "false");
            });
          }
        }
      }, 100);
    },
    setIntervalToCheckLiveStream() {
      if (this.intervalSet) return;
      this.intervalSet = true;
      this.intervalTimer = setInterval(() => {
        this.checkTimeToGetLinkLiveStream();
      }, 60000);
    },
    checkTimeToGetLinkLiveStream() {
      if (!this.eventStartTime) return;
      const nowUTC = new Date();
      const eventStartDateTime = new Date(this.eventStartTime);
      const nowLocalTime = new Date(nowUTC.getTime() + 2 * 60 * 60 * 1000);
      const startTimeLocalTime = new Date(
        eventStartDateTime.getTime() + 2 * 60 * 60 * 1000
      );
      if (
        nowLocalTime.getTime() >=
        startTimeLocalTime.getTime() - 3 * 60 * 1000
      ) {
        this.handleGetLinkLiveStream(this.gameId);
      }
    },
    clearInterval() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
        this.intervalSet = false;
      }
    },
    handleUnVisible() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "@/public/scss/components/live-stream/index.scss";
</style>
